import { defineComponent as _defineComponent } from 'vue'
import BCXTagSelect from '@/components/tagging/BCXTagSelect.vue';
import { PropType } from 'vue';
import { ExternalTagAssignment } from '@/services/TaggingService';
import { useVModel } from '@vueuse/core';
import X from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXTagSelectAdd',
  props: {
  value: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'skill'
  },
  tagListOfCurrentType: {
    type: Array as PropType<ExternalTagAssignment[]>,
    default: () => []
  },
  isTagActionEnabled: {
    type: Boolean,
    default: true
  },
  mode: {
    type: String as PropType<'add' | 'delete'>,
    default: 'add'
  },
  placeholderText: {
    type: String,
    default: ''
  }
},
  emits: ['selectFocus', 'selected', 'noRoles', 'addTag', 'delete'],
  setup(__props, { emit }) {

const props = __props;




const tagValue = useVModel(props);

function onTagAction() {
  if (!props.isTagActionEnabled) return;
  if (props.mode === 'add') emit('addTag');
  else emit('delete');
}


return { __sfc: true,props, emit, tagValue, onTagAction, BCXTagSelect, X }
}

})